




































import { computed, defineComponent } from '~/utils/nuxt3-migration'
import CSubtitleButton from '~/components/shared/configurable/button/CSubtitleButton.vue'
import { useNamespacedStore } from '~/compositions/store'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
export default defineComponent({
  components: {
    CSubtitleButton
  },
  props: {
    minimumPrice: { type: [String, Number], required: true },
    loading: { type: Boolean, default: false },
    containerClasses: { type: [String, Array], required: false, default: '' }
  },
  setup() {
    const { getters } = useNamespacedStore(CLASSIFIED_VIEW_NS)
    const forBikes = computed<boolean>(() => getters('isBikeClassified'))
    const forVans = computed<boolean>(() => getters('isVanClassified'))

    const expertButtonImageExtension = computed(() => {
      if (forBikes.value) {
        return '-bike'
      } else if (forVans.value) {
        return '-van'
      }
      return ''
    })
    return {
      forBikes,
      expertButtonImageExtension
    }
  }
})
